"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FuehrungsrinnenFilter = void 0;
/**
 * Filter for Fuehrungsrinnen and Montage Sets
 */
class FuehrungsrinnenFilter {
    constructor() { }
    /**
     * Filter the given Fuehrungsrinnen list and only return Fuehrungsrinnen that are compatible with
     * the given Kette.
     *
     * @param fuehrungsrinneList list of all available Fuehrungsrinnen
     * @param kette the given Kette
     * @returns filtered Array of Fuehrungsrinnen
     */
    static filterFuehrungsrinnenByKette(fuehrungsrinneList, kette) {
        const rinnenFilter = [];
        if (kette && kette.rinneRef && kette.rinnenvarianteRef) {
            kette.rinnenvarianteRef.forEach((variante) => {
                if (variante.rinneRef) {
                    variante.rinneRef.forEach((rinneRef) => {
                        if (kette.rinneRef.indexOf(rinneRef) !== -1) {
                            rinnenFilter.push(rinneRef);
                        }
                    });
                }
            });
        }
        const filteredFuehrungsrinnen = fuehrungsrinneList.toArray().filter((fuehrungsrinne) => {
            return fuehrungsrinne.id && rinnenFilter.indexOf(fuehrungsrinne.id) !== -1;
        });
        return filteredFuehrungsrinnen;
    }
    /**
     * Filter the given Montage Set list and only return Montage Sets that are compatible with
     * the given Kette.
     *
     * @param montageSetList list of all available Montage Sets
     * @param kette the given Kette
     * @returns filtered Array of Montage Sets
     */
    static filterMontageSetsByKette(montageSetList, kette) {
        const montageSetFilter = [];
        if (kette && kette.montagesetRef && kette.rinnenvarianteRef) {
            kette.rinnenvarianteRef.forEach((variante) => {
                if (variante.montagesetRef) {
                    variante.montagesetRef.forEach((montagesetRef) => {
                        if (kette.montagesetRef.indexOf(montagesetRef) !== -1) {
                            montageSetFilter.push(montagesetRef);
                        }
                    });
                }
            });
        }
        const filteredMontageSets = montageSetList.toArray().filter((montageSet) => {
            return montageSet.id && montageSetFilter.indexOf(montageSet.id) !== -1;
        });
        return filteredMontageSets;
    }
    /**
     * Filter the given Montage Set list and only return Montage Sets that are compatible with
     * the given Fuehrungsrinne and Kette.
     *
     * @param montageSetList list of all available Montage Sets
     * @param fuehrungsrinne the given Fuehrungsrinne
     * @param kette the given Kette
     * @returns filtered Array of Montage Sets
     */
    static filterMontageSetsByFuehrungsrinneKette(montageSetList, fuehrungsrinne, kette) {
        const montageSetFilter = [];
        if (fuehrungsrinne && kette && kette.montagesetRef && kette.rinnenvarianteRef) {
            kette.rinnenvarianteRef.forEach((variante) => {
                if (variante.rinneRef &&
                    variante.montagesetRef &&
                    fuehrungsrinne.id &&
                    variante.rinneRef.indexOf(fuehrungsrinne.id) !== -1) {
                    variante.montagesetRef.forEach((montagesetRef) => {
                        if (kette.montagesetRef.indexOf(montagesetRef) !== -1) {
                            montageSetFilter.push(montagesetRef);
                        }
                    });
                }
            });
        }
        const filteredMontageSets = montageSetList.toArray().filter((montageSet) => {
            return montageSet.id && montageSetFilter.indexOf(montageSet.id) !== -1;
        });
        return filteredMontageSets;
    }
    /**
     * Find all Montage Sets that can be used with the given Fuehrungsrinne and Kette.
     *
     * @param montageSetList list of all available Montage Sets
     * @param fuehrungsrinne the given Fuehrungsrinne
     * @param kette the given Kette
     * @returns filtered Array of Montage Sets
     */
    static filterMontageSetsByFuehrungsrinneKetteMontageSetTyp(montageSetList, fuehrungsrinne, kette) {
        return this.filterMontageSetsByFuehrungsrinneKette(montageSetList, fuehrungsrinne, kette).filter((set) => set.isMontageSetOhneCProfil() ||
            set.isMontageSetMitCProfil() ||
            set.isBefestigungInnen() ||
            set.isBefestigungAussen());
    }
    /**
     * Find all Festpunktmodule that can be used with the given Fuehrungsrinne and Kette.
     *
     * @param montageSetList list of all available Montage Sets
     * @param fuehrungsrinne the given Fuehrungsrinne
     * @param kette the given Kette
     * @param ae AE for the given Kette
     * @returns filtered Array of Montage Sets
     */
    static filterMontageSetsByFuehrungsrinneKetteFestpunktmodulTyp(montageSetList, fuehrungsrinne, kette, ae) {
        return this.filterMontageSetsByFuehrungsrinneKette(montageSetList, fuehrungsrinne, kette).filter((festpunktmodul) => festpunktmodul.isFestpunktModul() && ae.isFestpunktmodulAllowed(festpunktmodul, kette));
    }
    /**
     * Filter the given Fuehrungsrinnen list and only return Fuehrungsrinnen that are compatible with
     * the given Fuehrungsrinne and Kette.
     *
     * @param fuehrungsrinneList list of all available Fuehrungsrinnen
     * @param fuehrungsrinne the given Fuehrungsrinne
     * @param kette the given Kette
     * @returns filtered Array of Fuehrungsrinnen
     */
    static filterFuehrungsrinnenByFuehrungsrinneKette(fuehrungsrinneList, fuehrungsrinne, kette) {
        const rinnenFilter = [];
        if (fuehrungsrinne && kette && kette.rinnenvarianteRef) {
            kette.rinnenvarianteRef.forEach((variante) => {
                if (variante.rinneRef && fuehrungsrinne.id && variante.rinneRef.indexOf(fuehrungsrinne.id) !== -1) {
                    variante.rinneRef.forEach((rinneRef) => {
                        if (kette.rinneRef.indexOf(rinneRef) !== -1) {
                            rinnenFilter.push(rinneRef);
                        }
                    });
                }
            });
        }
        const filteredFuehrungsrinnen = fuehrungsrinneList.toArray().filter((fuehrungsrinneListItem) => {
            return fuehrungsrinneListItem.id && rinnenFilter.indexOf(fuehrungsrinneListItem.id) !== -1;
        });
        return filteredFuehrungsrinnen;
    }
}
exports.FuehrungsrinnenFilter = FuehrungsrinnenFilter;
//# sourceMappingURL=fuehrungsrinnen-filter.js.map